import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';


// Переводы
const resources = {
  en: {
    translation: {
      UserName:"User name",
      Password:"Password",
      RememberMe:"Remember me",
      SignIn:"Sign in with credentials",
      welcome: "Welcome to our website!",
      ForgotPassword:"Forgot password?",
      logout: "Logout",
      login:"Login",
      CreateNewAccount:"Create new account",
      CalcTimes: "Calc times",
      CalcStats: "Calculations stats",
      CalculatorStats:"Calculator stats",
      Dashboard: "Dashboard",
      DicomConverter: "DICOM converter",
      MeshConverter: "MESH converter",
      Files: "Files",
      CalcYear: "Calculations statistics for the year",
      DicomDesc: "DICOM image Converter to NIFTI",
      Convert: "Convert",
      FilePlaceholder: "Select a file or drag here",
      MESHDesc: "Create FEM MESH from NII (Neuroimaging Informatics Technology Initiative)",
      T1: "T1 weighted image",
      T2: "T2 weighted image",
      Create: "Create",
      MeshHistory: "Mesh converting history",
      StartDate: "Start Date",
      EndDate: "End Date",
      PageSize: "Page Size",
      Filter: "Filter",
      StartedDate: "Started date",
      CalculationStatus: "Calculation status",
      FullLogs: "Full work logs",
      ResultMesh: "Result mesh",
      File: "File",
      Upload: "Upload",
      Calculations: "Calculations",
      SortBy: "Sort by Date",
      Desc: "Descending",
      Asc: "Ascending",
      DateCalc: "Date of calculation",
      Results: "Results",
      ResultsFiles: "Results Files",
      inputDataParameters: "input data parameters",
      diagnosticPoint: "Diagnostic point",
      HeatTransferCoefficient: "Heat transfer coefficient [W/m2K]",
      AmbientTemperatureF: "Ambient temperature f(t) [℃], t must be in seconds",
      MeshFile: "Mesh file",
      PropertiesOfFabrics: "Properties of fabrics",
      thermal_conductivity: "Thermal conductivity [W/m/k] ",
      heat_capacity: "Heat capacity [J/K kg]",
      density: "Density [kg/m^3]",
      initial_temperature: "Initial temperature [℃]",
      WM: "White material",
      GM: "Grey material",
      csf: "Cerebrospinal Fluid",
      scalp: "Scalp",
      eye: "Eye",
      compact_bone: "Compact bone",
      spinal_bone: "Spinal bone",
      blood: "Blood",
      muscles: "Muscles",
      Calc: "Calculate",
      Close:"Close",
      Save:"Save changes",
      Home:"Home",
      Register:"Register",
      Cabinet:"Cabinet",
      Auth:"Please register or login to use the service",
      ViewFiles:'View files',
      Converting:"Converting...",
      Creating:'Creating...',
      radius:"Radius [mm]",
      skull:"Skull",
      surface_brain:"Surface brain",
      deep_brain:"Deep Brain",
      RealTimeData:"Real time data",
      center:"Center",
      surface:"Surface",
      Ta:" Ambient Temperature [℃]",
      Temperature:"Temperature, °C",
      Time:"Time",
      ForensCalc:"Forensic calculators",
      ForensDesc:"for determining the age of death by thermometric method",
       Rectum:"Rectum",
      Brain:"Brain",
      TimeDeath:"Time since death, hours",
      MinTimeDeath:"Min. time since death, hours",
      MaxTimeDeath:"Max. time since death, hours",
      CoolingCurve:"Cooling Curve",
      IterationsProcess:"3D Iterations Process",
      MinFunc:"Minimisation function with gradient descent",
      T1measurement: 'Body temperature at the first measurement (℃)',
      T2measurement: 'Body temperature at the re-measurement (℃)',
      dt: 'Time interval between measurements (hours)',
      T0: 'Initial body temperature at the measurement point (℃)',
      CalculationCompleted:"Calculation completed successfully!",
      b:"Direct temperature coefficient",
      lower:"Lower limit",
      upper:"Upper limit",
    }
  },
  ru: {
    translation: {
      UserName:"Имя пользователя",
      Password:"Пароль",
      RememberMe:"Запомнить меня",
      SignIn:"Войдите с вашими данными",
      welcome: "Добро пожаловать на наш сайт!",
      CreateNewAccount:"Создать новый аккаунт",
      ForgotPassword:"Забыли пароль?",
      logout: "Выйти",
      login:"Войти",
      CalcTimes: "Время расчетов",
      CalcStats: "Статистика расчетов",
      CalculatorStats:"Статистика калькуляторов",
      Dashboard: "Панель управления",
      DicomConverter: "Конвертер DICOM",
      MeshConverter: "Конвертер MESH",
      Files: "Файлы",
      CalcYear: "Статистика расчетов за год",
      DicomDesc: "Конвертация изображений DICOM в NIFTI",
      Convert: "Конвертировать",
      FilePlaceholder: "Выберите файл или перетащите его сюда",
      MESHDesc: "Создание FEM MESH из NII (Инициатива информатики в области нейровизуализации)",
      T1: "Т1-взвешенное изображение",
      T2: "Т2-взвешенное изображение",
      Create: "Создать",
      MeshHistory: "История конвертации MESH",
      StartDate: "Дата начала",
      EndDate: "Дата окончания",
      PageSize: "Размер страницы",
      Filter: "Фильтровать",
      StartedDate: "Дата начала",
      CalculationStatus: "Статус расчета",
      FullLogs: "Полные рабочие логи",
      ResultMesh: "Результирующая сетка",
      File: "Файл",
      Upload: "Загрузить",
      Calculations: "Расчеты",
      SortBy: "Сортировать по дате",
      Desc: "по убыванию",
      Asc: "по возрастанию",
      DateCalc: "Дата расчета",
      Results: "Результаты",
      ResultsFiles: "Файлы результатов",
      inputDataParameters: "Входные параметры данных",
      diagnosticPoint: "Диагностическая точка",
      HeatTransferCoefficient: "Коэффициент теплопередачи [Вт/(м2·К)]",
      AmbientTemperatureF: "Температура окружающей среды f(t) [℃], t должно быть в секундах",
      MeshFile: "Файл сетки",
      PropertiesOfFabrics: "Свойства тканей",
      thermal_conductivity: "Теплопроводность [Вт/(м·К)]",
      heat_capacity: "Теплоемкость [Дж/(кг·К)]",
      density: "Плотность [кг/м³]",
      initial_temperature: "Начальная температура [℃]",
      WM: "Белое вещество",
      GM: "Серое вещество",
      csf: "Спинномозговая жидкость",
      scalp: "Кожа головы",
      eye: "Глаз",
      compact_bone: "Компактная кость",
      spinal_bone: "Спинная кость",
      blood: "Кровь",
      muscles: "Мышцы",
      Calc: "Рассчитать",
      Close:"Закрыть",
      Save:"Сохранить изменения",
      Home:'Главная',
      Register:"Регистрация",
      Cabinet:"Кабинет",
      Auth:"Пожалуйста войдите или зарегистрируйтесь",
      ViewFiles:'Посмотреть файлы',
      Converting:"Конвертирование...",
      Creating:'Создание...',
      radius:"Радиус [мм]",
      skull:"Череп",
      surface_brain:"Поверхность мозга",
      deep_brain:"Глубокие структуры мозга",
      RealTimeData:"Данные в реальном времени",
      center:"Центр",
      surface:"Поверхность",
      Ta:"Температура окружающей среды",
      Temperature:"Температура, °C",
      Time:"Время",
      Language:"Язык",
      ForensCalc:"Судебно-медицинские калькуляторы",
      ForensDesc:"для определения давности наступления смерти термометрическим методом",
      Rectum:"Ректальная температура",
      Brain:"Краниоэнцефальная температура",
      TimeDeath:"Время с момента наступления смерти, часы",
      MinTimeDeath:"Мин. время с момента наступления смерти, часы",
      MaxTimeDeath:"Макс. время с момента наступления смерти, часы",
      CoolingCurve:"Кривая охлаждения",
      IterationsProcess:"3D Процесс итерации",
      MinFunc:"Функция минимизации методом градиентного спуска",
      T1measurement: "Температура тела при первом измерении (℃)",
      T2measurement: "Температура тела при повторном измерении (℃)",
      dt: "Интервал времени между измерениями (часы)",
      T0: "Начальная температура тела в точке измерения (℃)",
      CalculationCompleted:"Вычисления успешно начаты, ожидайте!",
      b:"Линейный температурный коэффициент",
      lower:"Нижний предел",
      upper:"Верхний предел",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: Cookies.get('language') || 'en', // Язык по умолчанию
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
